import React from 'react';
import PublicNavBar from '../../components/shared/PublicNavBar';
import UserAccessSetup from '../../components/UserAccessSetup/UserAccessSetup';

const UserSignup = () => {
  return (
    <div>
      <div>
        <PublicNavBar />
      </div>
      <div className='userSignup_access_form'>Get started with Fam</div>
      <div className='setup_access'>
        <UserAccessSetup />
      </div>
    </div>
  );
};

export default UserSignup;
